import {Utils} from "./Utils";

/**
 * on dom ready
 */
Utils.executeWhenDocumentIsReady(() => {
    // Retrieve all elements by class name
    const offcanvasSearchPanel = document.querySelector<HTMLElement>(".c-offcanvas__search-panel");
    const langbutton = document.querySelector<HTMLElement>(".c-offcanvas .c-language-menu__button");
    const languageSelectContainer = document.querySelector<HTMLElement>(".c-offcanvas__language-select-container");

    // Open
    document.querySelector("[data-offcanvas-toggle]")?.addEventListener("click", () => {
        document.querySelector(".c-offcanvas").classList.add("c-offcanvas--is-open")
        document.querySelector(".o-page__overlay").classList.add("o-page__overlay--for-offcanvas")
    })

    // Close
    document.querySelector(".c-offcanvas__close").addEventListener("click", () => {
        if (
            offcanvasSearchPanel.classList.contains("c-offcanvas__search-panel--is-open",)
        ) {
            offcanvasSearchPanel.classList.remove("c-offcanvas__search-panel--is-open",)
        } else {
            document.querySelector(".c-offcanvas").classList.remove("c-offcanvas--is-open")
            document.querySelector(".o-page__overlay").classList.remove("o-page__overlay--for-offcanvas")
        }
    })

    // Close with click outside
    document.querySelector<HTMLElement>(".o-page__overlay").addEventListener("click", function () {
        if (this.classList.contains("o-page__overlay--for-offcanvas")) {
            this.classList.remove("o-page__overlay--for-offcanvas")
            document.querySelector(".c-offcanvas").classList.remove("c-offcanvas--is-open")
        }
    })

    // Open submenu
    document.querySelectorAll<HTMLElement>(".c-offcanvas__navigation-item--has-subnavigation > .c-offcanvas__navigation-link")
        .forEach((el) => {
            el.addEventListener("click", function () {
                this.nextElementSibling?.classList.add(
                    "c-offcanvas__subnavigation--is-open",
                )
            })
        })

    // Close submenu
    document.querySelectorAll<HTMLElement>(".c-offcanvas__level-up")
        .forEach((el) => {
            el.addEventListener("click", function () {
                this.closest(".c-offcanvas__subnavigation")?.classList.remove(
                    "c-offcanvas__subnavigation--is-open",
                )
            })
        })

    // Open search panel
    document.querySelector(".c-offcanvas__search-button").addEventListener("click", () => {
        offcanvasSearchPanel.classList.add("c-offcanvas__search-panel--is-open",)
        langbutton?.classList.remove("c-language-menu__button--arrow-up");
        languageSelectContainer.style.display = "none";
        setTimeout(() => {
            ;(
                document.querySelector<HTMLElement>(".c-offcanvas__search-input")
            ).focus()
        }, 1000)
    })

    // Toggle language select
    langbutton?.addEventListener("click", function () {
        this.classList.toggle("c-language-menu__button--arrow-up")
        languageSelectContainer.style.display = languageSelectContainer.style.display === "none" ? "block" : "none"
    })

    // Adjust padding bottom if navigation / subnavigation header link has more than one line
    document
        .querySelectorAll<HTMLElement>(".c-offcanvas__subnavigation")
        .forEach((el) => {
            const height =
                el.querySelector(".c-offcanvas__header")?.clientHeight || 0
            if (height > 108) {
                el.style.paddingBottom = `${height / 16 + 36 / 16}rem`
            }
        })

    const navigation = document.querySelector<HTMLElement>(".c-offcanvas__navigation")
    if (
        navigation.querySelector(".c-offcanvas__header")?.clientHeight ||
        0 > 108
    ) {
        navigation.style.paddingBottom = `${
            (navigation.querySelector(".c-offcanvas__header")?.clientHeight ||
                0) /
            16 +
            36 / 16
        }rem`
    }
})
